import React, { useContext } from 'react';

import { EditorProps } from './Editor/types';

type IRequestContext = Pick<
  EditorProps,
  'getRequest' | 'postRequest' | 'useConvertFile' | 'enabledConvertibleImport'
>;

export const RequestContext = React.createContext<Partial<IRequestContext>>({
  getRequest: () => {},
  postRequest: () => {},
  enabledConvertibleImport: true,
});

export const useRequestContext = () => useContext(RequestContext);
